import { MapCard } from '@iotopen/lynx-react-components';
import 'leaflet/dist/leaflet.css';
import { Card } from 'react-bootstrap';

interface MapCardContainerProps {
    mapItems: any[],
    height: string | number
}

export const MapCardContainer = ({mapItems, height} : MapCardContainerProps) => {
    return <div className='mb-3'>
        {mapItems.length ? 
            <MapCard mapItems={mapItems} center={[25, 0]} zoom={1} height={height.toString() + 'vh'}/> : 
            <Card>
                <Card.Body className='mt-1'>
                    <h6>No devices with location data were found in this installation.</h6>
                </Card.Body>
            </Card>}
    </div>;
};